import styles from './TradeInStatus.scss';
import { ITradeItem, TradeInStatus as TradeInStatusTypes } from '~/types/tradein';
import { useDispatch } from 'react-redux';
import { Popup, PopupBody, PopupFooter, PopupHeader } from '~/components/Popup/Popup';
import { t } from '~/utils/localization';
import Button from '~/components/Button/Button';
import WoWSEntity from '@wg/wows-entities/wrappers/react/WoWSEntity';
import classNames from 'classnames';
import { appActions } from '~/Store/appSlice';
import { getRarityForItem } from '~/utils/rarity';

interface ITradeInStatus {
    data: {
        status: TradeInStatusTypes;
        item: ITradeItem;
    };
}

const TradeInStatus = ({ data }: ITradeInStatus) => {
    const dispatch = useDispatch();

    const onClose = () => {
        dispatch(appActions.changeVisibilityPopup({ name: null }));
    };

    const isSuccess = data.status === TradeInStatusTypes.SUCCESS;

    const classesImages = classNames(styles.image, {
        [styles.error]: !isSuccess,
    });

    const rarity = getRarityForItem(data.item.type, data.item.identifier);

    return (
        <Popup onClose={onClose} popupClassName={styles.popup}>
            <PopupHeader title={isSuccess ? t('Обмен завершён') : t('Произошла ошибка. Повторите попытку позже')} />
            <PopupBody>
                {isSuccess && rarity && <div className={classNames(styles.shinyEffect, styles[rarity])} />}
                <img className={classesImages} src={data.item.images.small || data.item.images.big} alt={data.item.title} />
                <div className={styles.info}>
                    <WoWSEntity
                        type={data.item.type}
                        id={data.item.identifier}
                        presentation={{
                            renderWithoutFade: true,
                            hideNationIcon: true,
                            withShortText: true,
                        }}
                    />
                </div>
            </PopupBody>
            <PopupFooter>
                <Button label={t('Закрыть')} onClick={onClose} />
            </PopupFooter>
        </Popup>
    );
};

export default TradeInStatus;
